
const Data = [
    {
        images: "images/slider-1.jpg"
    },
    {
        images: "images/slider-2.jpg"
    },
    {
        images: "images/slider-3.jpg"
    }
]








export default Data;